import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Forretning from './Forretning.jsx'
import ForretningIcon from '../../../images/Forretning.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class ForretningList extends Component {
    state = {
        forretninger: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null        
    }

    getForretninger = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/matrikkelenhet/${this.props.matrikkelenhetId}/forretning`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken                
            }
        })
        .then(({data}) => {
            this.setState({
                forretninger: [...this.state.forretninger, ...data.forretninger].sort(this.forretningComparer),
                isLoading: false,
                continuationToken: data.nextContinuationToken
            })
        })
    }

    forretningComparer = (a, b) => {
        if (a.forretningsdokumentdato == null) return 1
        if (b.forretningsdokumentdato == null) return -1

        var firstDate = new Date(a.forretningsdokumentdato)
        var secondDate = new Date(b.forretningsdokumentdato)

        if (firstDate > secondDate) return -1
        if (firstDate < secondDate) return 1
        return 0
    }

    toggleForretninger = () => {
        if (this.props.antall == 0) return

        if (this.state.forretninger.length == 0) {
            this.getForretninger()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var antallForretninger = this.state.continuationToken ? `${this.state.forretninger.length}/${this.props.antall}` : this.props.antall        
        return (
            <li>
                <div className="section-header" onClick={this.toggleForretninger}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={ForretningIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('forretninger')} ({antallForretninger})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.forretninger.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.forretninger.map((f, index) => {return (<Forretning key={f.forretningId} forretning={f} antall={this.props.antall} isLast={index==this.state.forretninger.length-1} token={this.props.token} settings={this.props.settings} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getForretninger}>
                                <span>{t('hent.forretninger')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(ForretningList)